/**
 * Navegación dentro de una pantalla.
 *
 * Cada uno de los conteos de la barra de triage y los botones de nivel pantalla
 * ("Atacar el cuello de botella", "Cargar los datos que faltan") bajan al bloque
 * donde el problema se resuelve, sin cambiar de ruta. Tres módulos habían escrito
 * su propia versión de esto y solo una movía el foco: las otras dos dejaban al
 * teclado arriba mientras la vista bajaba, así que quien navega sin mouse
 * apretaba el conteo y no pasaba nada perceptible.
 */

/**
 * Lleva el scroll **y el foco** a una zona de la pantalla.
 *
 * El `tabindex="-1"` se pone acá y no en el markup de cada bloque porque es una
 * consecuencia de esta función: sin él un `div` o una `section` no reciben foco
 * programático, y sin foco el lector de pantalla sigue leyendo donde estaba.
 */
export function irA(id: string): void {
  const destino = document.getElementById(id)
  if (destino === null) return

  // jsdom no implementa scrollIntoView: sin el guard, un test que apriete el
  // botón explotaría por el entorno y no por el código.
  if (typeof destino.scrollIntoView === 'function') {
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  destino.setAttribute('tabindex', '-1')
  destino.focus({ preventScroll: true })
}
